import view from "../../views/pugb.js";
import { router } from "../router/index.routes.js";
import { _user, _handler, Clip } from "../classes/index.classes.js";
import KTAPI from "../api/index.api.js";
import { ioSocket, ioPings } from "../mm/index.mm.js";

import { errorMsg } from "./offscreen.controller.js";
import { KTLang } from "../lang/lang.js";
import KTCookie, { get } from "../components/cookie.js";
import { toggleLoader } from "../router/index.routes.js";


let states = [
    "DEAD",
    "WARM",
    "START",
    "FH",
    "HT",
    "SH",
    "OT",
    "END"    
];

let matchTypesColor = {
    "pug": "success",
    "mix": "primary",
    "scrim": "warning",
    "league": "danger",
    "tournament": "info"
};


let tempservers = [];


let serverSkeleton = `<div class="sv-lobby sv-lobby-eskeleton cursor-pointer d-table-row fs-8 text-gray-800 bgi-position-y-center lobby-map-bg" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%)">
<div class="d-table-cell py-2 px-3 ps-4 rounded-start align-middle">
    <div class="d-flex align-items-center justify-content-center">
        <div class="d-flex flex-column align-items-center gap-2">
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-badge"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-badge"></div>
        </div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="d-flex align-items-center flex-column">
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 50%;"></div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="d-flex flex-column">
        <div class="d-flex">
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
        </div>
        <div class="d-flex mt-2">
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
        </div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="d-flex flex-column lobby-scores lobby-live d-none">
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px; height: 30px;"></div>
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px; height: 30px;"></div>
    </div>
    <div class="d-flex flex-column lobby-empty-scores lobby-nolive">
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px; height: 30px;"></div>
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px; height: 30px;"></div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="d-flex flex-column align-items-center">
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 80px;"></div>
        <div class="d-flex align-items-center">
            <div class="me-2 skeleton-loader-pug-server skeleton-loader-pug-server-symbol"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 60px;"></div>
        </div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="d-flex align-items-center">
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px;"></div>
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px; margin-left: 5px;"></div>
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 20px; margin-left: 5px;"></div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="skeleton-loader-pug-server skeleton-loader-pug-server-text" style="width: 80px;"></div>
</div>
<div class="d-table-cell py-2 px-3 align-middle">
    <div class="d-flex align-items-center">
        <div class="skeleton-loader-pug-server skeleton-loader-pug-server-image"></div>
    </div>
</div>
<div class="d-table-cell py-2 px-3 pe-4 rounded-end align-middle">
    <div class="btn-toolbar my-1 justify-content-center" role="toolbar">
        <div class="btn-group z-index-3" role="group">
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-btn"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-btn"></div>
            <div class="skeleton-loader-pug-server skeleton-loader-pug-server-btn"></div>
        </div>
    </div>
</div>
</div>`;


let play = {
    render: () => {
        
        return view;
    },
    after_render: async () => {

        //renderSkeleton(true);
        //await toggleLoader(".servers-table");

        KTLang.update();
        let locs = await KTAPI.getSvPool();
        if(locs.message == 'done') {
            //renderLocList(locs.res);
            //renderSelectLocation(locs.res);
        }

        
        let servers = await KTAPI.getServers('competitive');
        //console.log(servers);
        
        if(servers.message == 'done' && servers.res.length > 0) { 

            //renderSkeleton(false);
            tempservers = servers.res;
            renderLobbyList(servers.res);
            
            //reorderServersList();
            
        }
        else
        {
            //$("#lobby-list-loader").addClass("d-none");
            $("#lobby-list-empty").removeClass("d-none");
        }

        //await toggleLoader(".servers-table");
        //$(".servers-list-loader").addClass("d-none");
        

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content'
};


$(document).ready(function(){

    _handler.on('ping', async (data) => {
        
    });
        
    
});

function reorderServersList()
{        
    sortServerDivs(".servers-live", ["data-ping","data-players"], [1, -1]);
    sortServerDivs(".servers-wait", ["data-ping","data-players"], [1, -1]);
}

/**
 * 
 *  SOCKET.IO PROCESSESS
 * 
 */

const pugSocket = (socket) => {

    //console.log("PUG SOCKET");
        
    socket.on("sv_update_pug", async (data) => {

        //$(`#lobby-${data.lobby._id}`).find(".lobby-players-num").text(`${data.lobby.playersnum}/${parseInt(data.lobby.vs)*2}`);
        let rawdata = JSON.stringify(data);
        let dataparsed = JSON.parse(rawdata);
        updateLobby(dataparsed.sv);
        reorderServersList();

    });   
    
    
    socket.on('lobby-error', async (data) => {
        errorMsg({title:"Hey!",content:data.msg});return;
    });

};

export { pugSocket };



/**
 * 
 *  RENDER FUNCTIONS
 * 
 */

const renderSkeleton = (bool) => {
    if(bool)
    {
        let html = /* html */`
        ${serverSkeleton}
        ${serverSkeleton}
        ${serverSkeleton}
        ${serverSkeleton}
        ${serverSkeleton}`;
        $(".servers-list.servers-wait").after(html);
    }
    else
    {
        $(".sv-lobby-eskeleton").remove();
    }
}

const renderLobbyList = (data) => {
    
    let htmllive = [];
    let html = [];
    let number = 0;
    data.map(sv => {
        sv.number = ++number;
        if(sv.live)
        {
            htmllive.push(renderLobbyTable(sv));
        }else{
            html.push(renderLobbyTable(sv));
        }
        
    });
    
    //$("#lobby-list-live").html('').append(htmllive);
    //$("#lobby-list-wait").html('').append(html);
    $(".servers-list.servers-live").after(htmllive);
    $(".servers-list.servers-wait").after(html);
    
    router.updatePageLinks();   
}

const renderLobbyTable = (data) => {

    let liveShadow = `live-shadow`;

    let maxperteam = parseInt(data.max_players) / 2;
    let emptyslot = `<div class="symbol symbol-30px cursor-pointer opacity-50 empty-slot">
        <span class="symbol-label border border-dashed border-gray-400">
            <i class="fad fa-user-plus"></i>
        </span>
    </div>`;
    let teamplayers = {};
    teamplayers.A = '';
    teamplayers.B = '';

    let numteamA = 0;
    let numteamB = 0;

    if(data.players === undefined || data.players == null) data.players = {};
    if(data.users === undefined || data.users == null) data.users = {};

    Object.keys(data.players).forEach(function(key, index) {
        let player = data.players[key];
        if(data.users[key] === undefined) data.users[key] = {};
        if(player.realteam == 'A')
        {
            teamplayers.A += `<div class="symbol symbol-30px cursor-pointer border-0 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${key}" data-team="${player.realteam}">
                                    <img src="${data.users[key].avatar === undefined ? 'assets/media/avatars/default.jpg' : data.users[key].avatar}" alt="">
                                </div>
                            `;
            numteamA++;
        }
        if(player.realteam == 'B')
        {
            teamplayers.B += `<div class="symbol symbol-30px cursor-pointer border-0 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${key}" data-team="${player.realteam}">
                                    <img src="${data.users[key].avatar === undefined ? 'assets/media/avatars/default.jpg' : data.users[key].avatar}" alt="">
                                </div>`;
            numteamB++;
        }
    });

    if(numteamA < maxperteam)
    {
        for(let i = numteamA; i < maxperteam; i++)
        {
            teamplayers.A += emptyslot;
        }
    }
    if(numteamB < maxperteam)
    {
        for(let i = numteamB; i < maxperteam; i++)
        {
            teamplayers.B += emptyslot;
        }
    }



    
    let html = /* html */`
        <tr id="sv-lobby-${data._id}" class="sv-lobby cursor-pointer fs-8 text-gray-800 bgi-position-y-center lobby-map-bg ${data.live ? 'lobby-is-live' : ''} ${data.live ? liveShadow : ''}" data-players="${data.act_players}" data-location="${data.location}" data-city="${data.city}" data-ping="${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? 9999: ioPings[data.location].ping}" data-sv-id="${data._id}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${data.map}.jpg');">
            <td class="ps-4 rounded-start align-middle" href="server/${data.server}" data-navigo>
                <!--<span class="my-1">${data.number}</span>-->
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column align-items-center gap-2">
                        <span class="badge badge-sm flex-shrink-0 align-self-center text-gray-200 mb-2 mb-sm-0 bg-${matchTypesColor[data.type]}">${data.type.toUpperCase()}</span>
                        <span class="badge badge-sm bg-light-primary flex-shrink-0 align-self-center text-primary lobby-state mb-2 mb-sm-0" data-i18n="play.${states[data.state]}"></span>
                    </div>                    
                </div>
            </td>
            <td class="align-middle" href="server/${data.server}" data-navigo>
                <div class="d-flex align-items-center flex-column">
                    <span class="fw-bold my-1 fs-7 text-gray-900 fw-bolder"><span class="lobby-act-players">${data.act_players}</span>/<span class="lobby-max-players">${data.max_players}</span></span>                    
                </div>
            </td>
            <td class="align-middle d-none d-lg-block">
                <div class="d-flex flex-column">
                    <div class="symbol-group group-teama symbol-hover flex-nowrap"> 
                        ${teamplayers.A}
                    </div>
                    <div class="symbol-group group-teamb symbol-hover flex-nowrap"> 
                        ${teamplayers.B}
                    </div>
                </div>
            </td>
            <td class="align-middle" href="server/${data.server}" data-navigo>
                <!--<div class="d-flex flex-column lobby-scores lobby-live ${data.live ? "" : "d-none"}">
                    <span class="lobby-scorea fs-3 fw-bolder ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span>
                    <span class="lobby-scoreb fs-3 fw-bolder ${data.scoreB > data.scoreA ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                </div>
                <div class="d-flex flex-column lobby-empty-scores lobby-nolive ${data.live ? "d-none" : ""}">
                    <span class="fs-3 fw-bolder">-</span>
                    <span class="fs-3 fw-bolder">-</span>
                </div>-->
                <div class="d-flex justify-content-around align-items-center lobby-scores lobby-live ${data.live ? "" : "d-none"}">
                    <span class="lobby-scorea fs-3 fw-bolder ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span><span class="">:</span><span class="lobby-scoreb fs-3 fw-bolder ${data.scoreB > data.scoreA ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                </div>
                <div class="d-flex justify-content-around align-items-center lobby-empty-scores lobby-nolive ${data.live ? "d-none" : ""}">
                    <span class="fs-3 fw-bolder">-</span><span class="">:</span><span class="fs-3 fw-bolder">-</span>
                </div>
            </td>
            <td class="align-middle text-nowrap" href="server/${data.server}" data-navigo>
                <div class="d-flex flex-column align-items-center">
                    <div class="d-flex align-items-center">
                        <span class="fw-boldest">${data.tag}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="me-2"><img class="" src="assets/media/flags/${data.flag}.gif"></div><span class="fw-bold my-1">${data.flag.toUpperCase()}, ${data.city.toUpperCase()}</span>
                    </div>
                </div>
            </td>
            <td class="align-middle text-nowrap" href="server/${data.server}" data-navigo>
                <i class="bi bi-bar-chart-fill ${getPingColor(ioPings[data.location] === undefined ? 9999 : ioPings[data.location])}" data-iconping="${data.location}"></i>
                <span class="fw-bold fs-7 my-1" data-showping="${data.location}">${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? `<div    class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[data.location].ping}</span>
                <span>ms</span>
            </td>
            <td class="align-middle" href="server/${data.server}" data-navigo>
                <!--<span class="fw-bold my-1 lobby-map-name">${data.map}</span>-->
                <span class="badge badge-sm badge-dark border border-primary flex-shrink-0 align-self-center text-primary fs-small lobby-map-name" style="background-color: rgba(27,27,27,0.8)">${data.map}</span>
            </td>
            <td class="align-middle" href="server/${data.server}" data-navigo>
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-${data.ac_required ? '30' : '20'}px" data-i18n="[title]faq.${data.ac_required ? 'ac' : 'vac'}" data-toggle="tooltip">
                        <!--<span class="symbol-label bg-gray-200 bg-opacity-75">-->
                            <img class="img-fluid" src="assets/media/logos/${data.ac_required ? 'akros-logo' : 'vac-logo'}.png" alt="">
                        <!--</span>-->
                    </div>
                </div>
            </td>
            <td class="pe-4 rounded-end align-middle">
            
                <div class="btn-toolbar my-1 justify-content-center" role="toolbar">
                    <div class="btn-group z-index-3" role="group">
                        <button class="btn btn-icon btn-light bg-gray-200 clip z-index-3" data-clipboard-text="connect ${data.server}" i18n-label="example.copied_server" data-toggle="tooltip" data-i18n="[title]play.copyip">
                            <i class="fas fa-clone"></i>
                        </button>
                        <a href="steam://connect/${data.server}" class="btn btn-icon btn-light bg-gray-200 btn-active-primary btn-active-color-gray-200 lobby-btn-connect external-handler z-index-3" data-toggle="tooltip" data-i18n="[title]play.connect">
                            <i class="fas fa-play"></i>
                        </a>
                        <a href="steam://connect/${data.hltv}" class="btn btn-icon btn-light bg-gray-200 btn-active-info btn-active-color-gray-200 lobby-btn-hltv external-handler z-index-3" data-toggle="tooltip" title="HLTV">
                            <i class="fas fa-tv"></i>
                        </a>
                    </div>
                </div>
                
            </td>
            
        </tr>
                `;
   
    
    html = $(html);
    
    html.localize();
    html.find("[data-toggle='tooltip']").tooltip();
    html.find("[data-toggle='tooltip']").attr("title", "");
    router.updatePageLinks();
    return html;
}

const renderLobby = (data) => {

    let liveShadow = `live-shadow`;

    let maxperteam = parseInt(data.max_players) / 2;
    let emptyslot = `<div class="symbol symbol-30px cursor-pointer opacity-50 empty-slot">
        <span class="symbol-label border border-dashed border-gray-400">
            <i class="fad fa-user-plus"></i>
        </span>
    </div>`;
    let teamplayers = {};
    teamplayers.A = '';
    teamplayers.B = '';

    let numteamA = 0;
    let numteamB = 0;

    if(data.players === undefined || data.players == null) data.players = {};
    if(data.users === undefined || data.users == null) data.users = {};

    Object.keys(data.players).forEach(function(key, index) {
        let player = data.players[key];
        if(data.users[key] === undefined) data.users[key] = {};
        if(player.realteam == 'A')
        {
            teamplayers.A += `<div class="symbol symbol-30px cursor-pointer border-0 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${key}" data-team="${player.realteam}">
                                    <img src="${data.users[key].avatar === undefined ? 'assets/media/avatars/default.jpg' : data.users[key].avatar}" alt="">
                                </div>
                            `;
            numteamA++;
        }
        if(player.realteam == 'B')
        {
            teamplayers.B += `<div class="symbol symbol-30px cursor-pointer border-0 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${key}" data-team="${player.realteam}">
                                    <img src="${data.users[key].avatar === undefined ? 'assets/media/avatars/default.jpg' : data.users[key].avatar}" alt="">
                                </div>`;
            numteamB++;
        }
    });

    if(numteamA < maxperteam)
    {
        for(let i = numteamA; i < maxperteam; i++)
        {
            teamplayers.A += emptyslot;
        }
    }
    if(numteamB < maxperteam)
    {
        for(let i = numteamB; i < maxperteam; i++)
        {
            teamplayers.B += emptyslot;
        }
    }



    
    let html = /* html */`
        <div id="sv-lobby-${data._id}" class="sv-lobby cursor-pointer d-table-row fs-8 text-gray-800 bgi-position-y-center lobby-map-bg ${data.live ? 'lobby-is-live' : ''} ${data.live ? liveShadow : ''}" data-players="${data.act_players}" data-location="${data.location}" data-city="${data.city}" data-ping="${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? 9999: ioPings[data.location].ping}" data-sv-id="${data._id}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${data.map}.jpg');">
            <div class="d-table-cell py-2 px-3 ps-4 rounded-start align-middle" href="server/${data.server}" data-navigo>
                <!--<span class="my-1">${data.number}</span>-->
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column align-items-center gap-2">
                        <span class="badge badge-sm flex-shrink-0 align-self-center text-gray-200 mb-2 mb-sm-0 bg-${matchTypesColor[data.type]}">${data.type.toUpperCase()}</span>
                        <span class="badge badge-sm bg-light-primary flex-shrink-0 align-self-center text-primary lobby-state mb-2 mb-sm-0" data-i18n="play.${states[data.state]}"></span>
                    </div>                    
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle" href="server/${data.server}" data-navigo>
                <div class="d-flex align-items-center flex-column">
                    <span class="fw-bold my-1 fs-7 text-gray-900 fw-bolder"><span class="lobby-act-players">${data.act_players}</span>/<span class="lobby-max-players">${data.max_players}</span></span>                    
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle">
                <div class="d-flex flex-column">
                    <div class="symbol-group group-teama symbol-hover flex-wrap"> 
                        ${teamplayers.A}
                    </div>
                    <div class="symbol-group group-teamb symbol-hover flex-wrap"> 
                        ${teamplayers.B}
                    </div>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle" href="server/${data.server}" data-navigo>
                <div class="d-flex flex-column lobby-scores lobby-live ${data.live ? "" : "d-none"}">
                    <span class="lobby-scorea fs-3 fw-bolder ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span>
                    <span class="lobby-scoreb fs-3 fw-bolder ${data.scoreB > data.scoreA ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                </div>
                <div class="d-flex flex-column lobby-empty-scores lobby-nolive ${data.live ? "d-none" : ""}">
                    <span class="fs-3 fw-bolder">-</span>
                    <span class="fs-3 fw-bolder">-</span>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle" href="server/${data.server}" data-navigo>
                <div class="d-flex flex-column align-items-center">
                    <div class="d-flex align-items-center">
                        <span class="fw-boldest">${data.tag}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="me-2"><img class="" src="assets/media/flags/${data.flag}.gif"></div><span class="fw-bold my-1">${data.flag.toUpperCase()}, ${data.city.toUpperCase()}</span>
                    </div>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle" href="server/${data.server}" data-navigo>
                <i class="bi bi-bar-chart-fill ${getPingColor(ioPings[data.location] === undefined ? 9999 : ioPings[data.location])}" data-iconping="${data.location}"></i>
                <span class="fw-bold fs-7 my-1" data-showping="${data.location}">${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? `<div    class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[data.location].ping}</span>
                <span>ms</span>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle" href="server/${data.server}" data-navigo>
                <span class="fw-bold my-1 lobby-map-name">${data.map}</span>
            </div>
            <div class="d-table-cell py-2 px-3 align-middle" href="server/${data.server}" data-navigo>
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-${data.ac_required ? '30' : '20'}px" data-i18n="[title]faq.${data.ac_required ? 'ac' : 'vac'}" data-toggle="tooltip">
                        <!--<span class="symbol-label bg-gray-200 bg-opacity-75">-->
                            <img class="img-fluid" src="assets/media/logos/${data.ac_required ? 'akros-logo' : 'vac-logo'}.png" alt="">
                        <!--</span>-->
                    </div>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3 pe-4 rounded-end align-middle">
            
                <div class="btn-toolbar my-1 justify-content-center" role="toolbar">
                    <div class="btn-group z-index-3" role="group">
                        <button class="btn btn-icon btn-light bg-gray-200 clip z-index-3" data-clipboard-text="connect ${data.server}" i18n-label="example.copied_server" data-toggle="tooltip" data-i18n="[title]play.copyip">
                            <i class="fas fa-clone"></i>
                        </button>
                        <a href="steam://connect/${data.server}" class="btn btn-icon btn-light bg-gray-200 btn-active-primary btn-active-color-gray-200 lobby-btn-connect external-handler z-index-3" data-toggle="tooltip" data-i18n="[title]play.connect">
                            <i class="fas fa-play"></i>
                        </a>
                        <a href="steam://connect/${data.hltv}" class="btn btn-icon btn-light bg-gray-200 btn-active-info btn-active-color-gray-200 lobby-btn-hltv external-handler z-index-3" data-toggle="tooltip" title="HLTV">
                            <i class="fas fa-tv"></i>
                        </a>
                    </div>
                </div>
                
            </div>
            
        </div>
                `;
   
    
    html = $(html);
    
    html.localize();
    html.find("[data-toggle='tooltip']").tooltip();
    html.find("[data-toggle='tooltip']").attr("title", "");
    router.updatePageLinks();
    return html;
}

const getPingColor = (ping) => {
    if(ping <= 50) return "text-success";
    if(ping <= 100) return "text-zyellow";
    if(ping <= 150) return "text-zorange";
    if(ping <= 200) return "text-danger";
    if(ping <= 999) return "text-gray-600";
    return "text-muted";
};

function updateLobby(data)
{
    console.log(data);
    manageTempServers(data);
    let server = tempservers.find(sv => sv._id === data._id);
    let emptyslot = `<div class="symbol symbol-30px cursor-pointer opacity-50 empty-slot">
        <span class="symbol-label border border-dashed border-gray-400">
            <i class="fad fa-user-plus"></i>
        </span>
    </div>`;

    Object.keys(data).forEach(function(key, index) {
        if(key == 'connected')
        {
            if(data[key] == false)
            {
                if($("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+data.steamid+"']").length)
                {
                    let team = $("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+data.steamid+"']").attr("data-team");
                    $("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+data.steamid+"']").remove();
                    $("#sv-lobby-"+data._id).find(`.group-team${team.toLowerCase()}`).append(emptyslot);
                }
            }
            else
            {
                /*let player = data.players[data.steamid];
                let user = data.users[data.steamid];
                let symbol = `<div class="symbol symbol-30px cursor-pointer border-0 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.steamid}" data-team="${player.realteam}">
                                <img src="${user.avatar}" alt="">
                            </div>`;
                let team = player.realteam;
                $("#sv-lobby-"+data._id).find(`.group-${team.toLowerCase()} .empty-slot`).first().remove();
                $("#sv-lobby-"+data._id).find(`.group-${team.toLowerCase()}`).append(symbol);*/
            }
        }
        if(key == 'players')
        {            
            if(data.players == undefined || data.players == null) data.players = {};
            Object.keys(data.players).forEach(function(k, index) {

                if(server.users === undefined || server.users[k] === undefined) return;
                
                let player = data.players[k];
                let user = server.users[k];

                if(player.realteam == 'A' || player.realteam == 'B')
                {
                    if($("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+k+"']").length)
                    {
                        if($("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+k+"']").attr("data-team") != player.realteam)
                        {
                            $("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+k+"']").remove();                            

                            $("#sv-lobby-"+data._id).find(`.group-team${player.realteam == 'A' ? 'b' : 'a'}`).append(emptyslot);
                            
                        }
                        else
                        {
                            return;
                        }
                    }
                    
                    let symbol = `<div class="symbol symbol-30px cursor-pointer border-0 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${k}" data-team="${player.realteam}">
                                    <img src="${user.avatar === undefined ? 'assets/media/avatars/blank.png' : user.avatar}" alt="">
                                </div>`;
                    let team = player.realteam;
                    console.log(team, k, user.avatar, symbol);
                    $("#sv-lobby-"+data._id).find(`.group-team${team.toLowerCase()} .empty-slot`).first().remove();
                    $("#sv-lobby-"+data._id).find(`.group-team${team.toLowerCase()}`).prepend(symbol);
                }
                else
                {
                    if($("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+k+"']").length)
                    {
                        let team = $("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+k+"']").attr("data-team");
                        $("#sv-lobby-"+data._id).find(".symbol[data-steamid='"+k+"']").remove();
                        $("#sv-lobby-"+data._id).find(`.group-team${team.toLowerCase()}`).append(emptyslot);                        
                    }
                }
            });

        }
        if(key == 'map')
        {                        
            let css = $("#sv-lobby-"+data._id).attr("style");            
            css = css.replace(/url\('assets\/media\/maps\/300px\/.*\.jpg'\)/, `url('assets/media/maps/300px/${data[key]}.jpg')`);
            $("#sv-lobby-"+data._id).attr("style", css);
            
            $("#sv-lobby-"+data._id).find(".lobby-map-name").text(data[key]);        
        }
        if(key == 'act_players')
        {   
            if(data[key] == 0) 
            {
                $("#sv-lobby-"+data._id).find(`.group-teama`).html(`${emptyslot}${emptyslot}${emptyslot}${emptyslot}${emptyslot}`);
                $("#sv-lobby-"+data._id).find(`.group-teamb`).html(`${emptyslot}${emptyslot}${emptyslot}${emptyslot}${emptyslot}`);
            }
            $("#sv-lobby-"+data._id).attr("data-players", data[key]);         
            $("#sv-lobby-"+data._id).find(".lobby-act-players").text(data[key]);
            if(data[key] >= data.max_players)
            {
                $("#sv-lobby-"+data._id).find(".lobby-btn-connect").addClass("disabled");
            }
            else
            {
                $("#sv-lobby-"+data._id).find(".lobby-btn-connect").removeClass("disabled");
            }
            
        }
        if(key == 'state')
        {                        
            $("#sv-lobby-"+data._id).find(".lobby-state").attr("data-i18n", "play."+states[data[key]]).localize();
        }
        if(key == 'scoreA' || key == 'scoreB' || key == 'teamA_name' || key == 'teamB_name')
        {
            $("#sv-lobby-"+data._id).find(".lobby-scorea").text(data.scoreA);
            $("#sv-lobby-"+data._id).find(".lobby-scoreb").text(data.scoreB);
            $("#sv-lobby-"+data._id).find(".lobby-namea").text(data.teamA_name == '' ? 'TEAM_A': data.teamA_name);
            $("#sv-lobby-"+data._id).find(".lobby-nameb").text(data.teamB_name == '' ? 'TEAM_B': data.teamB_name);
        }
        if(key == 'live')
        {
            if(data[key] == true){
                if(!$("#sv-lobby-"+data._id).hasClass('lobby-is-live'))
                {
                    $("#sv-lobby-"+data._id).insertAfter(".servers-list.servers-live");
                }
                
                $("#sv-lobby-"+data._id).find(".lobby-nolive").addClass("d-none");
                $("#sv-lobby-"+data._id).find(".lobby-live").removeClass("d-none");
                $("#sv-lobby-"+data._id).addClass('lobby-is-live');
                $("#sv-lobby-"+data._id).addClass('live-shadow');
            }
            if(data[key] == false){
                if($("#sv-lobby-"+data._id).hasClass('lobby-is-live'))
                {
                    $("#sv-lobby-"+data._id).insertAfter(".servers-list.servers-wait");
                }
                $("#sv-lobby-"+data._id).find(".lobby-nolive").removeClass("d-none");
                $("#sv-lobby-"+data._id).find(".lobby-live").addClass("d-none");
                $("#sv-lobby-"+data._id).removeClass('lobby-is-live');
                $("#sv-lobby-"+data._id).removeClass('live-shadow');
            }
        }
    });
    $("#sv-lobby-"+data._id).localize();
    router.updatePageLinks();      
}

function manageTempServers(data){
    
    tempservers = tempservers.map(server => {
        if (server._id === data._id) {
    
            if(data.hasOwnProperty('connected'))
            {
                if(data.connected == false)
                {
                    if(server.players[data.steamid]) delete server.players[data.steamid];
                    if(server.users[data.steamid]) delete server.users[data.steamid];
                    if(server.stats[data.steamid]) delete server.stats[data.steamid];                    
                }
                else
                {
                    if(server.players == undefined) server.players = {};
                    if(server.users == undefined) server.users = {};
                    if(server.stats == undefined) server.stats = {};
                    server.players[data.steamid] = data.player;
                    server.users[data.steamid] = data.user;
                    server.stats[data.steamid] = data.stats;
                }
            }
            else
            {
                if(data.hasOwnProperty('act_players') && data.act_players == 0)
                {
                    server.players = {};
                    server.users = {};
                    server.stats = {};
                }
                Object.keys(data).forEach(key => {
                    server[key] = data[key];
                });            
            }
        }
        return server;
    }); 
}

function sortServerDivs(parentSelector, attributes, order) {
    var $divs = $(`${parentSelector} ~ div`).detach();

    $divs.sort(function(a, b) {
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            var aValue = $(a).attr(attr);
            var bValue = $(b).attr(attr);

            // Comprobar si los valores son números
            if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = Number(aValue);
                bValue = Number(bValue);
            }

            // Comparar los valores
            if (aValue < bValue) {
                return -1 * order[i];
            } else if (aValue > bValue) {
                return 1 * order[i];
            }
        }

        // Si llegamos a este punto, todos los atributos son iguales
        return 0;
    });

    // Reinsertar los divs en el div padre
    //console.log($divs);
    $(`${parentSelector}`).parent().append($divs);
}







export default play;